import type { TarotCardItem } from '@/types';
import styles from './CardItem.module.css';

export function CardItem({ emoji, name, description }: TarotCardItem) {
  return (
    <div className={styles.item}>
      <div className={styles.nm}>
        <span className={styles.em} aria-hidden>
          {emoji}
        </span>
        {name}
      </div>
      <div className={styles.ds}>{description}</div>
    </div>
  );
}
